export default __webpack_public_path__ + "static/media/icon-info-circle.368a4ff5.svg";